import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../header/header';
import Navvbar from '../../header/Navvbar';
import Footer from '../../footer';


const SettingOverview = () => {
  return (
    <>
    <Header/>
    <Navvbar/>
    <br/>
    <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}}>
      <div className="row">
         <div className="col-md-10">
                   <div className="main-content">
                     <h2>My Lab Settings</h2>
                     <div>
           <div style={{ columnCount: 1 }}>
             <Link to="/Tabs" style={{ textDecoration: 'none', fontSize: '19px',color: '#004aad', }}>
               <h6 style={{ margin: 0 }}><b>Lab Details</b></h6>
             </Link>
             <p style={{ fontSize: '16px', margin: '5px 0 0' }}>Manage the lab details for your lab including configurations.</p>
           </div>
         
           <div style={{ columnCount: 1 }}>
             <Link to="/" style={{ textDecoration: 'none', fontSize: '19px',color: '#004aad' }}>
               <h6 style={{ margin: 0 }}><b>Store</b></h6>
             </Link>
             <p style={{ fontSize: '16px', margin: '5px 0 0' }}>View and manage your store settings and products.</p>
           </div>
         
           <div style={{ columnCount: 1 }}>
             <Link to="/users" style={{ textDecoration: 'none', fontSize: '19px',color: '#004aad' }}>
               <h6 style={{ margin: 0 }}><b>Users</b></h6>
             </Link>
             <p style={{ fontSize: '16px', margin: '5px 0 0' }}>Manage DDX users for your lab, including adding new users and updating existing.</p>
           </div>
         
           <div style={{ columnCount: 1 }}>
             <Link to="/" style={{ textDecoration: 'none', fontSize: '19px',color: '#004aad' }}>
               <h6 style={{ margin: 0 }}><b>Permission Groups</b></h6>
             </Link>
             <p style={{ fontSize: '16px', margin: '5px 0 0' }}>Control permission settings for different user groups in your lab.</p>
           </div>
         
           <div style={{ columnCount: 1 }}>
             <Link to="/accountTable" style={{ textDecoration: 'none', fontSize: '19px',color: '#004aad' }}>
               <h6 style={{ margin: 0 }}><b>Accounts</b></h6>
             </Link>
             <p style={{ fontSize: '16px', margin: '5px 0 0' }}>Manage financial accounts and billing information for your lab.</p>
           </div>
         
           <div style={{ columnCount: 1 }}>
             <Link to="/financeOwerview" style={{ textDecoration: 'none', fontSize: '19px',color: '#004aad' }}>
               <h6 style={{ margin: 0 }}><b>Finances</b></h6>
             </Link>
             <p style={{ fontSize: '16px', margin: '5px 0 0' }}>Review and manage all the financial aspects related to your lab's services.</p>
           </div>
         
           <div style={{ columnCount: 1 }}>
             <Link to="/casesetting" style={{ textDecoration: 'none', fontSize: '19px',color: '#004aad' }}>
               <h6 style={{ margin: 0 }}><b>Case Setting</b></h6>
             </Link>
             <p style={{ fontSize: '16px', margin: '5px 0 0' }}>Configure settings for handling different cases within your lab.</p>
           </div>       
                    </div>
                   </div>
                 </div>
      </div>
    </div>
    <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
    <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}} >
    <Footer/>
    </div>
    </>
  );
}

export default SettingOverview;
